export default __webpack_public_path__ + "static/media/5Stars_Blue@1x.fb2b7081.svg";